module.exports = __webpack_public_path__ + "img/3.19c8a0fc.png";